import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import TabellaLista from '../../../components/Tabella/TabellaLista';
import { videoDaApprovare } from '../../../../api-client/appPlayer';

/*
 * Video di presentazione da approvare (sportid-docs, interventi del 7-8/10/2026, sez. E): li caricano le
 * strutture e non compaiono nell'app finche` SportID non li approva. La riga apre la scheda, dove si guarda
 * il video e si approva o si rifiuta con il motivo.
 */

export const LIST_URL = '/superadmin/video-presentazione';

const dataBreve = (iso) => (iso ? new Date(iso).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '');

export const ListaVideoPresentazione = () => {
    const navigate = useNavigate();
    const [righe, setRighe] = useState(null);
    const [errore, setErrore] = useState('');

    useEffect(() => {
        videoDaApprovare().then((r) => {
            if (!r || r.error) { setErrore(r?.error || 'Impossibile leggere i video da approvare.'); setRighe([]); return; }
            setRighe(r.map((v) => ({ ...v, sostituisce: v.hasApproved ? 'Sì' : 'No', stato: 'In attesa' })));
        });
    }, []);

    const data_column = [
        { Header: 'Caricato', Footer: 'Caricato', accessor: 'uploadedAt', compact: true, disableGlobalFilter: true, Cell: ({ value }) => dataBreve(value) },
        { Header: 'Struttura', Footer: 'Struttura', accessor: 'clubName', larghezza: '40%' },
        { Header: 'Sostituisce un video approvato', Footer: 'Sostituisce un video approvato', accessor: 'sostituisce', disableGlobalFilter: true },
        {
            Header: 'Stato',
            Footer: 'Stato',
            accessor: 'stato',
            disableGlobalFilter: true,
            Cell: ({ value }) => (
                <div className="d-flex align-items-center">
                    <i className="fa fa-circle me-1 text-warning"></i>
                    <div>{value}</div>
                </div>
            ),
        },
    ];

    return (
        <>
            <Modal show={!!errore} onHide={() => setErrore('')} centered>
                <Modal.Header closeButton><Modal.Title>Errore durante l'operazione</Modal.Title></Modal.Header>
                <Modal.Body>{errore}</Modal.Body>
            </Modal>
            <TabellaLista
                openColumn={'clubName'}
                openRow={(row) => navigate(`${LIST_URL}/${row.clubId}`)}
                cardTitle={'Video di presentazione'}
                pageList={true}
                hasSearch={true}
                searchPlaceholder={'Cerca per struttura'}
                hasFilter={false}
                hasAddMore={false}
                data_column={data_column}
                data_json={righe}
                sort_by={'uploadedAt'}
                sort_type={'asc'}
            />
        </>
    );
};

export default ListaVideoPresentazione;
